<div [class.loading]="loader.loading">
  <div *ngIf="quickquote$ | async as quickquote">
    <div class="bootstrap quick-quote" [appScrollIntoView]="quickquote.currentPage">
      <ng-container *ngIf="mode === 'quickquote'">
        <div class="quick-quote__card" *ngIf="!quickquote">
          Questionnaire {{ name }} not found
        </div>

        <div class="quick-quote__card" *ngIf="quickquote">
          <app-apg-quick-quote-header [quickQuote]="quickquote">
          </app-apg-quick-quote-header>

          <div class="quick-quote__footer" [ngSwitch]="quickquote.currentPage?.type">
            <app-apg-quick-quote-page *ngSwitchDefault [page]="quickquote.currentPage"
                                      [firstPage]="quickquote.currentPageIndex === 0" (opened)="open($event)"
                                      (findExisting)="goToFullQuote($event)">
            </app-apg-quick-quote-page>

            <app-apg-quick-quote-summary *ngSwitchCase="'Summary'" [quickQuote]="quickquote">
            </app-apg-quick-quote-summary>

            <app-apg-quick-quote-otp *ngSwitchCase="'Otp'" [quickQuote]="quickquote"
                                     (next)="saveOtp(quickquote, $event.code)"
                                     (back)="quickquote.currentPage.prevPage()">
            </app-apg-quick-quote-otp>

            <app-apg-quick-quote-complete *ngSwitchCase="'Complete'" [quickQuote]="quickquote"
                                          (continue)="saveCoverBasis($event)">
            </app-apg-quick-quote-complete>

            <app-apg-quick-quote-critical-illness *ngSwitchCase="'Inclusions'" [quote]="quote" [quickQuote]="quickquote"
                                                  (continue)="quoteSelected($event)" (back)="quickquote.back(5)">
            </app-apg-quick-quote-critical-illness>

            <app-apg-quick-quote-final-summary *ngSwitchCase="'FinalSummary'" [quote]="selectedQuote"
                                               [quickQuote]="quickquote" [page]="quickquote.currentPage"
                                               (back)="quickquote.back()" (continue)="continueQuote($event)">
            </app-apg-quick-quote-final-summary>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="mode === 'coverCalculator'">
        <apg-cover-calculator (continue)="onCoverCalculated($event.detail)" (back)="backToQuickQuote()">
        </apg-cover-calculator>
      </ng-container>

      <ng-container *ngIf="mode === 'fullquote'">
        <app-apg-full-quote [key]="quoteKey" [quickQuote]="quickquote" [quote]="selectedQuote"
                            (back)="backToQuickQuote()" (newQuote)="newQuote()">
        </app-apg-full-quote>
      </ng-container>

    </div>
  </div>

  <div class="apg-panel loader">
    <div class="loading" *ngIf="!error">
      <div class="invalid-feedback">Please wait...</div>
      <ion-spinner></ion-spinner>
    </div>
    <div class="loading " *ngIf="error">
      <div class="invalid-feedback">{{ error }}</div>
    </div>
  </div>
</div>